// Rule ordering helpers for final CSS assembly.
// Example: keep `@charset/@import/@layer;` before style rules.

// Split leading header at-rules from all other rendered rules.
export function splitHeaderRules(cssRules: string[]): [string[], string[]] {
  const headerRules: string[] = []
  const bodyRules: string[] = []
  let headerPhase = true

  // Keep only leading header rules in the header section.
  for (const rule of cssRules) {
    // Route non-header rules into body and close header phase.
    if (!headerPhase || !isHeaderDirectiveRule(rule)) {
      headerPhase = false
      bodyRules.push(rule)
    } else {
      // Keep valid header directives in output header.
      headerRules.push(rule)
    }
  }

  // Return partitioned [header, body] rule arrays.
  return [headerRules, bodyRules]
}

// Detect supported header directives that must stay before style rules.
function isHeaderDirectiveRule(rule: string): boolean {
  const trimmed = rule.trim().toLowerCase()

  // Match `@charset` declaration lines.
  if (trimmed.startsWith('@charset ')) {
    return true
  } else if (trimmed.startsWith('@import ')) {
    // Match `@import ...;` declaration lines.
    return true
  } else if (trimmed.startsWith('@layer ') && trimmed.endsWith(';')) {
    // Match `@layer ...;` declaration lines.
    return true
  } else {
    // Return false for non-header rules.
    return false
  }
}
